import React, { useState } from 'react';
import { Tabs, Skeleton, Typography } from '../';
import classNames from 'classnames';
import { RightOutlined, DownOutlined, InfoCircleFilled } from '@ant-design/icons';
import { Notification } from '../Notification';
import { useCollapse } from '../../hooks';
import './NotificationsPanel.scss';

const { Title, Text } = Typography;

// Tabs unused for now
const TAB_ITEMS = [
    { key: 'all', label: 'All' },
    { key: 'actions', label: 'Actions' },
    { key: 'alerts', label: 'Alerts' },
    { key: 'errors', label: 'Errors' },
];

// Tabs unused for now
const TAB_TYPE_MAP = {
    actions: 'action',
    alerts: 'warning',
    errors: 'error',
};

export const NotificationsPanel = ({ notifications = [], isLoading = false }) => {
    const [activeTab, setActiveTab] = useState('actions');
    const [collapsed, toggle] = useCollapse(true);

    if (notifications.length === 0) return null;

    const filtered =
        activeTab === 'all'
            ? notifications
            : notifications.filter((n) => n.notification_type === TAB_TYPE_MAP[activeTab]);

    const actionLabel = `${filtered.length} Action ${filtered.length === 1 ? 'Item' : 'Items'}`;

    return (
        <div className="panel-wrapper notifications-panel">
            <div
                className="notifications-panel-header notifications-panel-header--clickable"
                onClick={toggle}
                aria-expanded={!collapsed}
            >
                <div className="notifications-panel-title-tabs">
                    <Title level={2} className="notifications-panel-title">
                        Notifications
                    </Title>
                    {collapsed && (
                        <span className="notifications-panel-collapsed-summary">
                            <InfoCircleFilled className="notifications-panel-collapsed-summary-icon" />
                            <Text className="notifications-panel-collapsed-summary-text">{actionLabel}</Text>
                        </span>
                    )}
                    {/* No tabs needed for now
                    <Tabs
                        activeKey={activeTab}
                        onChange={setActiveTab}
                        items={TAB_ITEMS}
                        size="small"
                        className="notifications-panel-tabs"
                    /> */}
                </div>
                {collapsed ? (
                    <RightOutlined className="notifications-panel-caret" />
                ) : (
                    <DownOutlined className="notifications-panel-caret" />
                )}
            </div>
            <div className={classNames('notifications-panel-body', { collapsed })}>
                <div className="notifications-panel-body-inner">
                    <div className="notifications-panel-list">
                        {isLoading ? (
                            <Skeleton active paragraph={{ rows: 2 }} className="notifications-panel-skeleton" />
                        ) : filtered.length === 0 ? (
                            <Text className="notifications-panel-empty">No notifications</Text>
                        ) : (
                            filtered.map((n) => (
                                <Notification
                                    key={n.id}
                                    type={n.notification_type}
                                    title={n.title}
                                    description={n.description}
                                    link={n.link}
                                />
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
